const adminAppTags = {
  actions: {
    add: '添加标签',
    delete: '删除',
    open: '打开 {{name}} 的操作菜单',
    rename: '重命名',
  },
  columnSelector: {
    label: '选择应用标签列表列',
    trigger: '列',
  },
  createDialog: {
    confirm: '创建标签',
    title: '添加标签',
  },
  deleteDialog: {
    confirm: '确认删除',
    noApps: '当前没有绑定应用。',
    subtitle: '删除标签后，已绑定应用会失去这个标签。',
    subtitleWithName: '删除标签“{{name}}”后，已绑定应用会失去这个标签。',
    title: '删除标签',
  },
  description: '用于给应用做业务分类，方便筛选和管理。',
  dialog: {
    cancel: '取消',
    close: '关闭弹窗',
  },
  empty: '暂无数据',
  errors: {
    duplicateName: '标签已存在，请换一个名称。',
    loadFailed: '请稍后重试，或检查当前管理员是否仍有访问权限。',
    loadTitle: '应用标签加载失败',
    loadWithDetail: '后端返回：{{detail}}',
    notFound: '标签不存在或已被删除。',
    operationFailed: '操作失败，请稍后重试。',
    permissionDenied: '当前管理员没有修改应用标签的权限。',
  },
  filters: {
    searchLabel: '搜索应用标签',
    searchPlaceholder: '搜索应用标签',
  },
  feedback: {
    createSuccess: '标签已创建',
    deleteSuccess: '标签已删除',
    updateSuccess: '标签已保存',
  },
  form: {
    nameLabel: '标签名称',
    namePlaceholder: '请输入标签名称',
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  renameDialog: {
    confirm: '保存',
    title: '重命名标签',
  },
  retry: '重试',
  sort: {
    createdAtAsc: '按创建时间升序排列',
    createdAtDesc: '按创建时间降序排列',
    updatedAtAsc: '按更新时间升序排列',
    updatedAtDesc: '按更新时间降序排列',
  },
  table: {
    actions: '操作',
    appCount: '应用数量',
    createdAt: '创建时间',
    createdBy: '创建人',
    name: '应用标签',
    updatedAt: '最后更新时间',
    updatedBy: '最后更新人',
  },
  title: '应用标签',
  validation: {
    nameRequired: '请输入标签名称。',
  },
  workspaceLabel: '应用标签工作区',
}

export default adminAppTags
